import { z } from "zod/v4";
import { withZeroTransaction } from "../../zero/utils";
import { createInsertSchema } from "../../utils/sql";
import { draft } from "./draft.sql";
import { zql } from "../../zero/schema";
import { type QueryRowType, type Zero } from "@rocicorp/zero";
import { defineQuery } from "../../zero/transformer";
import { must } from "@corpuscomplete/core/utils";

export namespace Draft {
  export type Info = QueryRowType<typeof all>;
  export const all = defineQuery(z.undefined(), ({ ctx }) => {
    return zql.draft.where("userId", "=", ctx.actor.userId);
  });

  export const byType = (z: Zero, type: string) => zql.draft.where("type", "=", type).one();

  export type Set = z.infer<typeof set.schema>;
  export const set = withZeroTransaction(createInsertSchema(draft), async ({ tx, ctx, args }) => {
    must(args.userId === ctx.actor.userId, "You do not have permission to set this draft");
    const timeNow = Temporal.Now.instant();
    await tx.mutate.draft.upsert({
      ...args,
      // Shouldn't use upsert if we care about preserving timeCreated, but we don't with drafts
      timeCreated: timeNow,
      timeUpdated: timeNow,
    });
  });

  export type Reset = z.infer<typeof reset.schema>;
  export const reset = withZeroTransaction(
    z.object({
      userId: z.uuid(),
      type: z.string(),
    }),
    async ({ tx, ctx, args }) => {
      must(args.userId === ctx.actor.userId, "You do not have permission to reset this draft");
      await tx.mutate.draft.delete(args);
    },
  );
}
